import { GeoUtils } from '../../../../utils/geo.utils';
import { HTMLUtils } from '../../../../utils/html.utils';
import { AbstractEditTool } from './abstract-edit-tool';
import { CCanvas } from './ccanvas';
import { ImageContainer } from './image-container';
import { Photo } from './photo';

export class Flip extends AbstractEditTool {
    image: HTMLImageElement;
    flipH: boolean;
    flipV: boolean;

    scaleX = 1;
    scaleY = 1;

    constructor(private photoModel: Photo, container: ImageContainer, private styles: any) {
        super(container);
    }

    public async load(): Promise<void> {
        // Driver.showImage();
        // this.image = await this.photoModel.populateXFromY(1200, true);
        // this.fitCanvasToContainer();
        // this.showCanvasOnly();
        // this.drawImage();
        this.container.notify('resize');
        HTMLUtils.addClass(this.photoModel.getEphemeralCanvas(), 'relative', this.styles.relative);
    }

    private fitCanvasToContainer() {
        this.getContainer().fitContainerToParent();
        const containerRect = HTMLUtils.getElementBoundingRectangle(this.getContainer().getElement());
        const imgRect = HTMLUtils.getImageNatualDimension(this.image);
        const rect = GeoUtils.containAbsolutePositionedChild(containerRect, imgRect);
    }

    public async flipHorizontally() {
        await this.flip_horizontal();
    }

    public async flipVertically() {
        await this.flip_vertical();
    }

    private drawImage() {
        this.container.showWithSpinner(() => {
            CCanvas.flip(this.photoModel.getPersistedCanvas(), this.photoModel.getEphemeralCanvas(), this.scaleX, this.scaleY);
            // CCanvas.applyFilter(this.photoModel.getCarmanCanvas(), FilterConfig.getCurrentFilterConfig(), this.photoModel.getEphemeralCanvas());
        });
    }

    public async flip_horizontal() {
        this.scaleX = -1 * this.scaleX;
        this.drawImage();

    }

    public async flip_vertical() {
        this.scaleY = -1 * this.scaleY;
        this.drawImage();
    }

    public async updateYImage(): Promise<HTMLImageElement> {
        if (this.scaleX != 1 || this.scaleY != 1) {
            CCanvas.flip2(this.photoModel.getPersistedCanvas(), this.scaleX, this.scaleY);
            CCanvas.copyCanvas(this.photoModel.getPersistedCanvas(), this.photoModel.getEphemeralCanvas());
            // Clear scale since download may call this method through finalize again
            this.scaleX = 1;
            this.scaleY = 1;
        }
        return null;
    }

    public handleResizeEvent(): void {
        this.container.notify('resize');
        if (1 === 1) { return; }
        this.fitCanvasToContainer();
        this.drawImage();
    }

    public resizeMouseDown(e) {
        // no-op
    }

    public mouseMove(e) {
        // no-op
    }

    public async finalize(): Promise<void> {
        const yImage = await this.updateYImage();
    }
}
